import { encoders } from './encoders';
import { root } from './monitors';

export const monitors = {
  ...root,
  encoders: {
    ...encoders,
  },
};
